// extracted by mini-css-extract-plugin
module.exports = {"citationImg":"Citation-module--citationImg--tzOz9","byline":"Citation-module--byline--1tPPP","dashStyle":"Citation-module--dashStyle---yia7"};